import http from 'hub-http/clients/apiClient';
import { HubsSettingClient } from 'frontend-preferences-client';
import { DEAL_SPLITS_ENABLED, FISCAL_OFFSET, STALE_SUBMISSION_FORECAST, HAS_SETUP_FORECAST_CATEGORIES } from '../constants/SettingsTypes';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { queryQuickFetch } from './earlyRequestHelper';

// GET & POST endpoint for setting that reflects whether an admin has seen portal-wide FMO onboarding
const PORTAL_FMO_ONBOARDING_STATUS_URI = 'forecasting/v1/onboarding';
const hubsSettingClient = HubsSettingClient.forCaller('forecasting-ui');

// Response always returns a Record<string, string>
// Comments next to each key specify the expected type of each after parsing
// must stay in sync with list in earlyRequester.js
// values in this object specify default values
const KEYS_TO_FETCH = {
  [DEAL_SPLITS_ENABLED]: 'false',
  [FISCAL_OFFSET]: 'null',
  [STALE_SUBMISSION_FORECAST]: 'null',
  [HAS_SETUP_FORECAST_CATEGORIES]: 'false'
};
const parsePortalSettings = settings => {
  const dealSplitsEnabled = settings[DEAL_SPLITS_ENABLED];
  const fiscalOffset = settings[FISCAL_OFFSET];
  const staleSubmissionForecast = settings[STALE_SUBMISSION_FORECAST];
  const hasSetupForecastCategories = settings[HAS_SETUP_FORECAST_CATEGORIES];
  return {
    [DEAL_SPLITS_ENABLED]: dealSplitsEnabled && JSON.parse(dealSplitsEnabled),
    [FISCAL_OFFSET]: fiscalOffset,
    [STALE_SUBMISSION_FORECAST]: staleSubmissionForecast ? parseInt(staleSubmissionForecast, 10) : null,
    [HAS_SETUP_FORECAST_CATEGORIES]: hasSetupForecastCategories && JSON.parse(hasSetupForecastCategories)
  };
};
export const getPortalSettings = () => hubsSettingClient.batchFetch(KEYS_TO_FETCH, EARLY_REQUESTER_KEYS.HUBS_SETTINGS).then(data => parsePortalSettings(data)).catch(error => logRavenException(error, 'Get Portal Settings', {
  earlyRequestKey: EARLY_REQUESTER_KEYS.HUBS_SETTINGS,
  KEYS_TO_FETCH: Object.keys(KEYS_TO_FETCH)
}));
export const setPortalSetting = (key, value) => hubsSettingClient.write(key, JSON.stringify(value));

// Not quite a Portal Setting, but close enough!
export const fetchPortalFmoOnboardingStatus = () => {
  return queryQuickFetch(EARLY_REQUESTER_KEYS.PORTAL_FMO_ADMIN_ONBOARDING, () => http.get(`${PORTAL_FMO_ONBOARDING_STATUS_URI}`));
};
export const updatePortalFmoOnboardingStatus = hasSeenPortalWideOnboarding => {
  return http.post(`${PORTAL_FMO_ONBOARDING_STATUS_URI}`, {
    data: hasSeenPortalWideOnboarding
  });
};